<template>
  <basic-container id = "community20211227">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.offlinePayUser_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, remove, update, getDictList, getCommunityPage,getProjectList } from '@/api/v4ward/property/community';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      userDetail:{},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        columnBtn: false,
        selection: true,
        searchMenuSpan: 12,
        labelWidth:110,
        column: [
          {
            label: '小区名称',
            prop: 'objectFullName',
            search:true,
            hide: false,
            searchSpan: 6,
            rules: [
              { required: true, message: '请输入名称', trigger: 'blur' },
              { min: 1,max: 12, message: '名称长度请设置为1-12位！' },
            ],
          },

          {
            label: '地址',
            maxlength: 200,
            showWordLimit: true,
            prop: 'roomName',
            hide: false,
            rules: [
              { required: true, message: '请输入地址', trigger: 'blur' },
            ],
          },
          {
            label: '类型',
            prop: 'useType',
            hide: false,
            type: 'select',
            dicUrl: '/api/base/property/getSortUseTypes?code=use_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            rules: [
              { required: true, message: '请选择类型', trigger: 'blur' },
            ],
          },
          {
            label: '所属项目',
            prop: "projectId",
            rules: [{
              required: true,
              message: "请选择项目名称",
              trigger: "change"
            }],
            type: 'select',
            cascaderItem:['deptId'],
            dicUrl: 'api/v4ward/project/getProjectList',
            props: {
              label: 'name',
              value: 'id',
            },
            search:true,
            editDisabled: false,
            viewDisplay: true,
            editDisplay: true,
          },

          {
            label: '所属机构',
            prop: 'deptId',
            placeholder: '请选择机构',
            //hide: true,
            // search :true,
            addDisplay: true,
            viewDisplay: true,
            editDisplay: true,
            type: 'tree',
            filterable: true,
            dicUrl: '/api/v4ward/dept/treeByProjectDeptId?projectId={{key}}',
            props: { label: 'title', value: 'id' },
            rules: [{ required: true, message: '请选择机构', trigger: 'change' }],
          },
          {
            label: '排序',
            prop: 'sort',
            maxlength: 10,
            showWordLimit: true,
            viewDisplay: true,
            editDisplay: true,
            rules: [
              { required: true, message: '请输入序号', trigger: 'blur' },
            ],
          },
          {
            label: '创建时间',
            prop: 'createTime',
            hide: false,
            addDisplay: false,
            viewDisplay: true,
            editDisplay: false,
          },
          {
            label: '开账截止时间',
            prop: 'billEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 140,
            rules: [
              {
                required: true,
                message: '请选择开账截止时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.offlinePayUser_add, true),
        viewBtn: this.vaildData(this.permission.offlinePayUser_view, true),
        delBtn: this.vaildData(this.permission.offlinePayUser_delete, true),
        editBtn: this.vaildData(this.permission.offlinePayUser_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      let type = typeof row.feeTypes;
      if (type!='string'){
        row.feeTypes = '';
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择小区删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['view'].includes(type)) {

      }
      if (['add'].includes(type)) {


      }
      if (['edit'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {

        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getCommunityPage(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss">
#community20211227 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
<style scoped>
.avue-crud el-form-item__content {
  text-align: right;
}
</style>
